export default {
  modules_image_drop() {
    return {
      imageDropAndPaste: {
        handler: (_data, _type, imageData) => {
          const file = imageData.toFile(imageData.name)
          this.insertImage(file)
        },
        nonImageHandler: (files) => this.addAttachments(files),
        insertImage: (file) => this.insertImage(file),
      },
    }
  },

  async insertImage(file) {
    const range = this.quill.getSelection() || { index: 0 }
    const input = this.hiddenInput.form.querySelector(
      'input[name="inline_attachments"]',
    )

    if (input) {
      // Body editor: upload to S3 via LiveView upload
      const contentId = file.name.toLowerCase().replace(/[^a-z0-9]/g, "")
      const src = URL.createObjectURL(file)
      // Caution: since LiveView 1.0.0, the order appears important
      // If the upload is initiated before the insertEmbed, the autostart
      // of the upload won't work.
      this.quill.insertEmbed(range.index, "blobImage", { src, contentId })
      this.quill.formatText(range.index, 1, "imageResize", {
        resize: "bestfit",
        title: "",
      })
      this.uploadTo(input.form, input.name, [file])
    } else {
      // Signature editor: no LiveView upload available, store as data URI so
      // the image persists across sessions without an S3 upload at compose time.
      const signatureImageId = crypto.randomUUID().replace(/-/g, "")
      const src = await fileToDataUri(file)
      this.quill.insertEmbed(range.index, "signatureImage", {
        src,
        signatureImageId,
      })
      this.quill.formatText(range.index, 1, "imageResize", {
        resize: "bestfit",
        title: "",
      })
    }
  },

  addAttachments(files) {
    const input = this.hiddenInput.form.querySelector('input[type="file"]')
    // Signature editor has no LiveView upload input; attachments unsupported.
    if (!input) return
    this.uploadTo(input.form, input.name, files)
  },
}

function fileToDataUri(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => resolve(e.target.result)
    reader.onerror = reject
    reader.readAsDataURL(file)
  })
}
